<template>
  <div>
    <el-dialog v-model="showRegister" width="600" :close-on-click-modal="false" @closed="closedRegister(ruleFormRef)"
      style="height: 360px;border-radius: 4px;
background: conic-gradient(from 90deg at 100% 50%, #FAFBFF 44.00728762149811deg, #F7F9FF 65.94390571117401deg, #F7FAFF 90deg, #F8FCFF 150.71987986564636deg, #ECF6FF 215.2921199798584deg, #F1F2FC 270.9080243110657deg, #EAEFFF 327.2787022590637deg, #FAFBFF 25.930346846580505deg);">

      <template #header="{ close, titleId, titleClass }">
        <div class="my-header">
          <div class="dialogtitle" style="font-size: 20px;">请自主登记以下信息</div>
        </div>
      </template>


      <el-form ref="ruleFormRef" :model="ruleForm" :rules="rules" style="margin: 0 auto;width: 500px;"
        label-position="left">
        <el-form-item label="单位名称" label-width="100px" prop="companyName">
          <el-input v-model="ruleForm.companyName" placeholder="请输入" clearable maxlength="30" show-word-limit />
        </el-form-item>
        <el-form-item label="联系人姓名" label-width="100px" prop="contactName">
          <el-input v-model="ruleForm.contactName" placeholder="请输入" clearable maxlength="10" show-word-limit />
        </el-form-item>

        <el-form-item label="联系方式" label-width="100px" prop="contactPhone">
          <div style="display: flex;width: 100%;">
            <el-input v-model="ruleForm.contactPhone" placeholder="请输入" style="width: 100%" clearable maxlength="11"
              show-word-limit />
            <el-button style="margin-left: 10px;" @click="Mgetcode" :disabled="codeTime"> <span
                v-if="!codeTime">获取验证码</span>
              <span v-if="codeTime">已发送</span> <span v-if="codeTime > 0">（{{ codeTime }}s）</span> </el-button>
          </div>

        </el-form-item>
        <el-form-item label="短信验证码" label-width="100px" prop="smsVerifyCode">
          <el-input v-model="ruleForm.smsVerifyCode" placeholder="请输入" />
        </el-form-item>

        <el-form-item class="btnbox">
          <div>
            <el-button @click="showRegister = false">取消</el-button>
            <el-button type="primary" @click="submitForm(ruleFormRef)">
              提交
            </el-button>
          </div>
        </el-form-item>

      </el-form>
    </el-dialog>


    <el-dialog v-model="showRegister2" width="580"
      style="height: 200px;border-radius: 4px;
background: conic-gradient(from 90deg at 100% 50%, #FAFBFF 44.00728762149811deg, #F7F9FF 65.94390571117401deg, #F7FAFF 90deg, #F8FCFF 150.71987986564636deg, #ECF6FF 215.2921199798584deg, #F1F2FC 270.9080243110657deg, #EAEFFF 327.2787022590637deg, #FAFBFF 25.930346846580505deg);"
      @closed="McanDownload">
      <template #header="{ titleClass }">
        <div style="display: flex; align-items: center">
          <el-icon color="green" style="font-size: 20px;">
            <CircleCheckFilled />
          </el-icon>
          <span style="margin-left: 6px;font-size: 20px;font-weight: 500; " class="dialogtitle">登记成功</span>


        </div>
      </template>



      <div class="successtip"> 中国招标投标公共服务平台运维实施人员会通过您预留的手机号与您取得联系，协助您部署CA互认共享组件。
      </div>

      <span  class="dialogFooter">
        <el-button type="primary" @click="showRegister2 = false">
          确定
        </el-button>
      </span>


     

    </el-dialog>
  </div>
</template>

<script lang='ts' setup>
import { reactive, toRefs, ref, defineProps, defineEmits, watch } from 'vue'
import type { ComponentSize, FormInstance, FormRules } from 'element-plus'
import {
  CircleCheckFilled,
} from '@element-plus/icons-vue'
import tmMitt from "../utils/tmMitt.ts";
import { getcode, addUser, addUser2 } from '../utils/axios/index.js'
import { ElMessage } from 'element-plus'
import { isMobile } from '../utils/validate'


// const props = defineProps({
//     showRegister: Boolean  
// });

const props = defineProps({
  showRegister: {
    type: Boolean,
  },
  registrationType: {
    type: Number
  }
});


let showRegister = ref(props.showRegister)
let registrationType = ref(props.registrationType)

watch(() => props.showRegister, (newValue) => {
  showRegister.value = newValue
  ruleForm.value.registrationType = props.registrationType
})






let showRegister2 = ref(false)
const ruleFormRef = ref()
const ruleForm = ref({
  companyName: "",
  contactName: "",
  contactPhone: "",
  registrationType: 0,
  smsVerifyCode: "",
})



let codeTime = ref(0)

const useCodeTimer = () => {
  codeTime.value = 60
  let timerId = null; // 用于存储定时器的ID  
  // 启动倒计时  
  if (timerId !== null) {
    // 如果定时器已经启动，则先清除旧的定时器  
    clearInterval(timerId);
  }
  timerId = setInterval(() => {
    if (codeTime.value > 0) {
      codeTime.value--;
    } else {
      // 时间到0，清除定时器  
      clearInterval(timerId);
      timerId = null;
      // 可以在这里添加时间到0后的处理逻辑  
      console.log('Countdown finished!');
    }
  }, 1000);



}

let isgetcode = ref(false)

const Mgetcode = () => {

  if (!ruleForm.value.contactPhone) {
    ElMessage({
      message: '请输入联系方式',
      type: 'warning',
    })
    return
  }
  if (ruleForm.value.contactPhone) {
    if (!isMobile(ruleForm.value.contactPhone)) {
      ElMessage({
        message: '手机号码格式不正确',
        type: 'warning',
      })

    } else {


      if (registrationType.value == -1) {
        addUser2({ sendSms: true, contactPhone: ruleForm.value.contactPhone }).then(res => {
          isgetcode.value = true
          useCodeTimer()
        })
      } else {
        getcode(ruleForm.value.contactPhone, registrationType.value).then(res => {
          isgetcode.value = true
          useCodeTimer()
        }).catch(err => {

        })
      }




    }

  }


}





const rules = ref({
  contactName: [
    { required: true, message: '请输入联系人姓名', trigger: 'blur' },
  ],

  companyName: [
    { required: true, message: '请输入单位名称', trigger: 'blur' },
  ],

  contactPhone: [
    { required: true, message: '请输入联系方式', trigger: 'blur' },
    {
      pattern: /^1[3456789]\d{9}$/,
      message: '请输入正确的手机号格式',
      trigger: 'blur',
    },
  ],

  smsVerifyCode: [
    { required: true, message: '请输入短信验证码', trigger: 'blur' },
  ],


})


const McanDownload = () => {
  emit('canDownload', false)
}

const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return
  await formEl.validate((valid, fields) => {
    if (valid) {
      console.log(ruleForm.value.smsVerifyCode!=='000000',ruleForm.value.smsVerifyCode);
      
      if (!isgetcode.value&&ruleForm.value.smsVerifyCode!=='000000') {
        ElMessage({
          message: '请获取并填写验证码后提交',
          type: 'warning',
        })
        return false
      }

      ruleForm.value.registrationType = registrationType.value
      if (registrationType.value == -1) {
        let parms = {
          contactName: "",
          contactPhone: "",
          organizationName: "",
          sendSms: false,
          verificationCode: ""
        }
        parms.contactName = ruleForm.value.contactName
        parms.contactPhone = ruleForm.value.contactPhone
        parms.organizationName = ruleForm.value.companyName
        parms.sendSms = false
        parms.verificationCode = ruleForm.value.smsVerifyCode


        addUser2(parms).then(res => {
          if (res.code == 200) {
            showRegister.value = false
            showRegister2.value = true
            McanDownload()
          }
        }).catch(err => {
          // ElMessage({
          //   message: err.data.msg,
          //   type: 'warning',
          // })
        })
      } else {
        addUser(ruleForm.value).then(res => {
          if (res.code == 200) {
            showRegister.value = false
            // showRegister2.value = true
            McanDownload()
          }
        }).catch(err => {
          // ElMessage({
          //   message: err.data.msg,
          //   type: 'warning',
          // })
        })
      }

    } else {
      console.log('error submit!', fields)
    }
  })
}

const resetForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return
  formEl.resetFields()
}

const emit = defineEmits(['canDownload', 'confirm'])

const closedRegister = (formEl: FormInstance | undefined) => {
  codeTime.value = 0
  resetForm(formEl)
  showRegister.value = false
  isgetcode.value = false
  emit('confirm')
}
</script>
<style lang="scss" scoped>
.btnbox {
  float: right;
  margin-top: 20px;
}

.dialogtitle {
  color: var(--Text-Text-11, #323335);
  font-feature-settings: 'clig' off, 'liga' off;
  
  font-style: normal;
  font-weight: 550;
  line-height: 24px;
  font-size: 20px;
}

.custom-label {
  color: var(--text-color-primary, #303133);

  
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  /* 157.143% */
  letter-spacing: -0.01px;
}

.el-dialog__body {
  padding: 10px;
}

.el-form {
  padding: 20px 0;
}

.successtip {
  padding: 20px
}
.dialogFooter{
  display: flex;
  flex-direction: row-reverse;
  margin-right: 20px;
  margin-top: 20px;

}
</style>